import { useCallback, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import QRScanner from "./QRScanner";
import { checkInTicket } from "./scannerApi";
import ScanResult from "./ScanResult";

export default function ScannerPage() {
  const navigate = useNavigate();

  const [result, setResult] = useState(null);
  const scanInProgressRef = useRef(false);

  const handleScan = useCallback(async (ticketUuid) => {
    if (scanInProgressRef.current) {
      return;
    }

    scanInProgressRef.current = true;

    try {
      const data = await checkInTicket(ticketUuid);
      setResult(data);
    } catch (error) {
      setResult({
        is_valid: false,
        message:
          error.response?.data?.detail || "Could not check ticket",
        name: "",
        ticket_type: "",
      });
    } finally {
      scanInProgressRef.current = false;
    }
  }, []);

  function handleContinue() {
    setResult(null);
  }

  function handleQuit() {
    navigate(-1);
  }

  return (
    <div className="relative min-h-[100dvh]">
      <button
        className="fixed left-4 top-4 z-50 inline-flex items-center gap-2 text-white"
        type="button"
        onClick={handleQuit}
      >
        <span className="text-4xl leading-none">❮</span>
        <span className="text-lg">Quit scanner</span>
      </button>

      {result ? (
        <ScanResult result={result} onContinue={handleContinue} />
      ) : (
        <QRScanner onScan={handleScan} />
      )}
    </div>
  );
}